import { Component, Input } from "@angular/core";
import { isLegalMagicCommander, isLegalMagicLegacy, isLegalMagicModern, isLegalMagicOathbreaker, isLegalMagicPauper, isLegalMagicPioneer, isLegalMagicStandard, isLegalMagicVintage } from "./magicCardLegality";
import { NgClass } from "@angular/common";

@Component({
    selector: "magic-card-legality",
    imports: [NgClass],
    templateUrl: "./magic-card-legality.component.html"
})
export class MagicCardLegalityComponent {
    @Input({ required: true }) public legalityMask!: number;

    public legalCommander!: boolean;
    public legalModern!: boolean;
    public legalStandard!: boolean;
    public legalPioneer!: boolean;
    public legalLegacy!: boolean;
    public legalVintage!: boolean;
    public legalOathbreaker!: boolean;
    public legalPauper!: boolean;

    constructor() {

    }

    public ngOnInit(): void {
        this.legalCommander = isLegalMagicCommander(this.legalityMask);
        this.legalModern = isLegalMagicModern(this.legalityMask);
        this.legalStandard = isLegalMagicStandard(this.legalityMask);
        this.legalPioneer = isLegalMagicPioneer(this.legalityMask);
        this.legalLegacy = isLegalMagicLegacy(this.legalityMask);
        this.legalVintage = isLegalMagicVintage(this.legalityMask);
        this.legalOathbreaker = isLegalMagicOathbreaker(this.legalityMask);
        this.legalPauper = isLegalMagicPauper(this.legalityMask);
    }
}